import './stylesheets';

const loadModules = () => {
    const modules = import.meta.glob([
        './Content/**/*.ts',
        './Extensions/**/*.ts',
    ])

    for (const path in modules) {
        modules[path]().catch(() => {
            // ignore module load failures to avoid breaking other modules
        })
    }
}

if (document.readyState === 'complete') {
    loadModules()
} else {
    window.addEventListener('load', loadModules)
}
